import AxiosConfig from '../utils/AxiosConfig';

class CoreMaintenanceService {
  async getGlobalCostRecalculationStatus() {
    const response = await AxiosConfig.get('/maintenance/jobs/global-cost-recalculation');
    return response.data.data;
  }

  async startGlobalCostRecalculation() {
    const response = await AxiosConfig.post('/maintenance/jobs/global-cost-recalculation', {});
    return response.data.data;
  }

  async startCompanyCostRecalculation(companyId) {
    const response = await AxiosConfig.post(`/maintenance/jobs/global-cost-recalculation/tenants/${companyId}`, {});
    return response.data.data;
  }
}

export default new CoreMaintenanceService();
